import type { DayStatus } from "../../common/src";

export const theme = {
  color: {
    primary: "#1d3557",
    primaryHover: "#16294a",
    /** Header background; lighter than primary so the dark boat logo stands out. */
    header: "#2a6f97",
    accent: "#e0a526",
    background: "#f5f7fa",
    surface: "#ffffff",
    text: "#1b2430",
    muted: "#5b6878",
    border: "#d9e0e8",
    danger: "#b42318",
    dangerBg: "#fdecea",
    success: "#1e7a46",
    successBg: "#e7f6ec",
    info: "#1d4f91",
    infoBg: "#e8f0fb",
  },
  day: {
    past: { bg: "#f0f2f5", fg: "#a3acb8" },
    unavailable: { bg: "#f7f8fa", fg: "#8b95a3" },
    available: { bg: "#e3f4ea", fg: "#14532d" },
    reserved: { bg: "#f6e3cf", fg: "#7c4a12" },
    mine: { bg: "#dbe8fb", fg: "#1d3557" },
  } satisfies Record<DayStatus, { bg: string; fg: string }>,
  radius: 8,
  shadow: "0 1px 2px rgba(16, 24, 40, 0.06), 0 1px 3px rgba(16, 24, 40, 0.1)",
  font: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
  narrow: "@media (max-width: 760px)",
};

export type VetBoatsTheme = typeof theme;
